/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Hero_Title_LeadInputs */

const en_platform_hero_title_lead = /** @type {(inputs: Platform_Hero_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach people,`)
};

const pl_platform_hero_title_lead = /** @type {(inputs: Platform_Hero_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prowadź treningi,`)
};

/**
* | output |
* | --- |
* | "Coach people," |
*
* @param {Platform_Hero_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_hero_title_lead = /** @type {((inputs?: Platform_Hero_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Hero_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_hero_title_lead(inputs)
	return en_platform_hero_title_lead(inputs)
});